<template>
  <div id="app">
    <h3>{{title}}</h3>
    <div class="col-md-12">
      <Character
       v-for="(id) in initial_ids"
       v-bind:id="id"
       
          />
    </div>
    
  </div>
</template>

<script>
import Character from './components/Character.vue'

export default {
  name: 'app',
  data() {
    return{
      title:'Click on card to generate random person',
      initial_ids:[1, 13, 14, 15, 33, 5]
    }
  },
  methods:{
     
  },
  components:{
    Character
  }
}
</script>